<template>
  <v-app>
    <!-- META-DATA -->
    <vue-headful
      :title="this.$store.state.app.meta.title + this.$store.state.app.meta.titleSuffix"
      :description="this.$store.state.app.meta.description" />

    <nav-bar v-if="$route.path !== '/comingsoon'" />
    <v-slide-y-transition>
      <nav-menu v-if="navMenu" />
    </v-slide-y-transition>
    <favorites-drawer v-if="isAuthenticated" />
    <cart-drawer />

    <v-snackbar
      v-model="snackbar.isActive"
      :timeout="snackbar.timeout"
      top>
      {{ snackbar.text }}
      <v-btn
        flat
        :color="snackbar.state"
        @click.native="snackbar.isActive = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-content
      class="content"
      :class="{ 'content--coming-soon': $route.path === '/comingsoon' }">
      <alert-banner
        v-if="$route.path !== '/custom/create' &&
          $route.path !== '/submit/create' &&
          $route.path !== '/comingsoon'" />
      <v-slide-y-transition mode="out-in">
        <router-view />
      </v-slide-y-transition>
    </v-content>

    <footer
      v-if="$route.path !== '/custom/create' &&
        $route.path !== '/submit/create' &&
        $route.path !== '/comingsoon'"
      class="footer">
      <div class="footer__info">
        <ul class="footer__contact">
          <li class="footer__subheader">
            MemerHats Ltd.
          </li>
          <li>
            For help or to report an issue,
            please email us at:
            <a href="mailto:memerhats@gmail.com">
              memerhats@gmail.com
            </a>
          </li>
        </ul>
        <ul class="footer__nav">
          <li>
            <router-link
              :to="{ name: 'terms-and-conditions' }"
              class="footer__nav-link">
              Terms and Conditions
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'privacy-policy' }"
              class="footer__nav-link">
              Privacy Policy
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'returns-policy' }"
              class="footer__nav-link">
              Returns and Exchanges
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'artist-agreement' }"
              class="footer__nav-link">
              Artist Agreement
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'patch-care' }"
              class="footer__nav-link">
              Patch Care Guide
            </router-link>
          </li>
        </ul>
        <div class="footer__social">
          <div class="footer__subheader">
            connect with memerhats
          </div>
          <div class="footer__social-links">
            <v-btn
              href="https://www.minds.com/memerhats/"
              outline
              icon
              large
              color="primary"
              class="footer__social-link">
              <icon-minds />
            </v-btn>
            <v-btn
              href="https://www.instagram.com/memerhats/"
              outline
              icon
              large
              color="primary"
              class="footer__social-link">
              <icon-instagram />
            </v-btn>
          </div>
        </div>
      </div>
      <div class="footer__copyright">
        Copyright &#169; 2019 MemerHats Ltd.
      </div>
    </footer>
  </v-app>
</template>

<script>
import NavBar from './components/NavBar.vue';
import NavMenu from './components/NavMenu.vue';
import FavoritesDrawer from './components/FavoritesDrawer.vue';
import CartDrawer from './components/CartDrawer.vue';
import AlertBanner from './components/AlertBanner.vue';

import IconInstagram from './components/icons/IconInstagram.vue';
import IconMinds from './components/icons/IconMinds.vue';

export default {
  name: 'App',
  components: {
    NavBar,
    NavMenu,
    FavoritesDrawer,
    CartDrawer,
    AlertBanner,
    IconInstagram,
    IconMinds,
  },
  data() {
    return {
      snackbar: {
        isActive: false,
        timeout: 2000,
        text: '',
      },
    };
  },
  computed: {
    navMenu() {
      return this.$store.state.app.navMenu;
    },
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    globalSnackbar() {
      return this.$store.state.app.globalSnackbar;
    },
  },
  created() {
    this.$store.watch(
      state => state.app.globalSnackbar.text,
      () => {
        const message = this.$store.state.app.globalSnackbar.text;
        if (message !== '') {
          this.snackbar.isActive = true;
          this.snackbar.text = message;
          this.$store.dispatch('app/globalMessage', '');
        }
      },
    );
  },
};
</script>

<style lang="stylus" scoped>
@require('./stylus/base')

// buffer for fixed nav bar
.content
  margin-top: 3rem
  background-color: $white
  &--coming-soon
    margin-top: 0
  /* hide navbar on tiny phones in landscape mode */
  // @media screen and (max-height: 24rem) and (orientation: landscape)
  //   margin-top: 0

.footer
  display: flex
  flex-flow: column nowrap
  align-items: center
  justify-content: center
  background-color: $white

  &__info
    display: flex
    flex-flow: row nowrap
    align-items: flex-start
    justify-content: space-between
    width: 100%
    max-width: 960px
  &__contact,
  &__nav,
  &__social
    list-style: none
    padding: $base-padding
  &__contact
    text-align: left
    max-width: 16rem
  &__nav
    text-align: center
  &__social
    text-align: right
  &__social-link
    margin: 0
    margin-top: $base-padding*.5
    margin-left: $base-padding

  @media screen and (max-width:48rem)
    &__info
      flex-flow: column nowrap
      align-items: center
      width: auto
    &__contact,
    &__nav,
    &__social
      text-align: center
      border-top: 1px solid $accent

  &__subheader
    @extends $base-subheader

  &__copyright
    width: 100%
    font-size: .6rem
    padding: $base-padding
    text-align: center
    text-transform: uppercase
    color: $secondary
    background-color: $black
    box-shadow: 0 500px 0 500px $primary


// PRINTER STYLES
@media print
  .footer
    display: none
</style>
